module.exports = __webpack_public_path__ + "img/pic_14.6cb625ce.jpg";